module.exports = __webpack_public_path__ + "static/media/vaibhav.851bedd4.jpg";